import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Textarea from '@/components/forms/Textarea';
import { useMemo } from 'react';
import { z } from 'zod';
import { useCommissionDetail } from './hooks/useCommission';
import useCommissionManage from './hooks/useCommissionManage';
import { useDynamicLocale } from '@/hoslog-intl';

const manageCommissionFormSchema = z.object({
  categoryName: z.string().min(1, { message: 'common.form.validation.required' }),
  description: z.string().optional(),
});
export const ManageCommissionCategoryForm = ({ categoryId }: { categoryId?: string }) => {
  const { commissionsDetail, isLoading } = useCommissionDetail(categoryId);
  const initialValues = useMemo(() => {
    if (!commissionsDetail || !categoryId) {
      return {
        categoryName: '',
        description: '',
      };
    }
    return {
      categoryName: commissionsDetail?.categoryName || '',
      description: commissionsDetail?.description || '',
    };
  }, [commissionsDetail, categoryId]);
  const form = useForm({ schema: manageCommissionFormSchema, mode: 'onBlur', values: initialValues });
  const { mutateAsync } = useCommissionManage();

  const { t } = useDynamicLocale();
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        await mutateAsync({
          categoryName: data.categoryName,
          description: data.description,
          categoryId: categoryId || '',
        });
      }}
    >
      <fieldset disabled={isLoading}>
        <div className="w-full flex flex-col gap-4.5">
          <Input
            label="configurationManagement.commissions.manageCommissionModal.categoryName"
            {...form.register('categoryName')}
            maxLength={50}
            placeholder={t('configurationManagement.commissions.manageCommissionModal.placeholder.enterCategoryName')}
          />

          <Textarea
            label="configurationManagement.commissions.manageCommissionModal.description"
            {...form.register('description')}
            className="resize-none"
            maxLength={200}
            placeholder={t('configurationManagement.commissions.manageCommissionModal.placeholder.writeSomething')}
          />
        </div>
      </fieldset>
    </Form>
  );
};
